var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmarkAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_18063_251)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 16,
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.25 19H22.75C22.3522 19 21.9706 19.158 21.6893 19.4393C21.408 19.7206 21.25 20.1022 21.25 20.5V37C21.2501 37.1338 21.286 37.2652 21.3539 37.3805C21.4219 37.4958 21.5195 37.5908 21.6366 37.6557C21.7537 37.7206 21.886 37.7529 22.0198 37.7494C22.1536 37.7458 22.284 37.7066 22.3975 37.6356L28 34.1341L33.6034 37.6356C33.7169 37.7063 33.8472 37.7454 33.9809 37.7488C34.1146 37.7522 34.2467 37.7198 34.3636 37.655C34.4806 37.5902 34.5781 37.4953 34.646 37.3801C34.7139 37.2649 34.7498 37.1337 34.75 37V20.5C34.75 20.1022 34.592 19.7206 34.3107 19.4393C34.0294 19.158 33.6478 19 33.25 19ZM33.25 35.6472L28.3966 32.6144C28.2774 32.5399 28.1396 32.5004 27.9991 32.5004C27.8585 32.5004 27.7208 32.5399 27.6016 32.6144L22.75 35.6472V20.5H33.25V35.6472Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_18063_251",
    x: -8,
    y: -8,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_18063_251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_18063_251",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkAdd);
export default __webpack_public_path__ + "static/media/bookmark-add.5e7c9edfd0383b5204b37f8b76d71cc1.svg";
export { ForwardRef as ReactComponent };